import { IconProp } from "@fortawesome/fontawesome-svg-core";

export class NavLink {
    icon: IconProp;
    route: string;
    description: string;
    title: string;
    children?: NavLink[];

    constructor(route: string, title: string, description: string, icon: IconProp) {
        this.route = route;
        this.title = title || null as any;
        this.description = description;
        this.icon = icon;
    }
}